import { CheckCircle2, Circle, Loader2, XCircle } from "lucide-react";

const STATUS_ICON = {
  done: CheckCircle2,
  running: Loader2,
  blocked: XCircle,
  failed: XCircle,
  pending: Circle,
};

const STATUS_CLASS = {
  done: "text-emerald-600",
  running: "text-[var(--primary)] animate-spin",
  blocked: "text-amber-600",
  failed: "text-red-500",
  pending: "text-[var(--text-tertiary)]",
};

export default function WorkflowStepTimeline({ steps = [] }) {
  if (!steps.length) return null;
  return (
    <div className="rounded-xl border border-[var(--border-default)] bg-[var(--bg-elev)] p-3 mb-3" data-testid="workflow-timeline">
      <p className="text-[10px] font-mono uppercase tracking-wider text-[var(--text-tertiary)] mb-2">Workflow</p>
      <ol className="space-y-2">
        {steps.map((step) => {
          const status = step.status || "pending";
          const Icon = STATUS_ICON[status] || Circle;
          return (
            <li key={step.id || step.title} className="text-xs">
              <div className="flex items-start gap-2">
                <Icon size={14} className={`shrink-0 mt-0.5 ${STATUS_CLASS[status] || STATUS_CLASS.pending}`} />
                <div className="min-w-0">
                  <span className={status === "done" ? "text-[var(--text-secondary)]" : "text-[var(--text-primary)]"}>
                    {step.title}
                  </span>
                  {step.detail ? (
                    <div className="text-[10px] text-[var(--text-tertiary)] mt-0.5 leading-snug">{step.detail}</div>
                  ) : null}
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
